import { Badge } from '@/components/ui/badge';
import type { TradeCurrentLocation } from '@/models/types';
import { useMemo } from 'react';
import { CURRENT_LOCATION_OPTIONS } from './trade-current-location-editor';

const TradeCurrentLocationBadge = ({
  currentLocation,
}: {
  currentLocation: TradeCurrentLocation;
}) => {
  const currentOption = useMemo(() => {
    return CURRENT_LOCATION_OPTIONS.find(
      (option) => option.value === currentLocation,
    );
  }, [currentLocation]);

  return (
    <Badge
      variant="ghost"
      className="cursor-pointer text-gray-500 text-left p-0"
    >
      {currentOption?.label ?? 'Not set'}
    </Badge>
  );
};

export default TradeCurrentLocationBadge;
